import { openings } from './Data'
const { urls, labels } = openings

function getOpeningsUrl(type) {
    if (!type) return;

    return urls[type]
}
    
function getOpeningsLabel(type) {
    if (!type) return;

    return labels[type]
}

export {
    getOpeningsUrl,
    getOpeningsLabel,
}